const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#efefef'
  },
  loginPage: {
    height: '100vh',
    width: '100vw',
    margin: 0,
  },
  image: {
    maxWidth: '100%',
  },
  logo: {
    padding: '7%'
  },
  bigBlue: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column'
  },
  loginContainer: {
    padding: '10% 10% 0',
    display: 'flex',
    flexWrap: 'wrap',
    height: '50vh',
    alignItems: 'center',
    justifyContent: 'left',
  },
  loginRight: {
    padding: '0!important',
    background: 'white',
  },
  gears: {
    marginTop: 'auto',
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  forgot: {
    paddingLeft: '6%',
    display: 'inline-block',
    marginLeft: '6%',
    lineHeight: '25px',
    borderLeft: '1px solid #D8D8D8',
    '& a': {
      color: theme.palette.primary.main,
    }
  },
  formWrapper: {
    width: '100vw',
    height: '100vh'
  },
  headline: {
    fontSize: '2rem'
  },
  signUp: {
    backgroundColor: '#F4F4F4',
    minHeight: '50vh',
    height: 'auto',
    padding: '10%',
  },
  langSelect: {
    marginTop: '-20px',
    alignSelf: 'start',
    '& button': {
      float: 'right',
    },
  },
  loginButton: {
    width: '135px',
    '& span': {
      letterSpacing: '0.5px',
      fontWeight: '400'
    }
  },
  signupButton: {
    minWidth: '135px',
    width: 'auto',
    wordBreak: 'break-all',
    backgroundColor: theme.palette.primary.light,
    '& a': {
      textDecoration: 'none',
      color: 'white',
      letterSpacing: '0.5px',
      fontWeight: '400',
    }
  },
  medium: {
    fontWeight: 500,
  },
  marginBottom: {
    marginBottom: '3vh',
  },
  signupText: {
    marginBottom: '3vh',
    '& p': {
      lineHeight: '28px',
      maxWidth: 500,
    }
  },
  downloadDesktop: {
    marginTop: '6%',
    padding: '20px 25px',
    backgroundColor: "#fff",
    fontSize: '0.875rem',
    lineHeight: '1.46429em',
    fontWeight: 500,
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`
  },
})

export default styles
